import React from 'react';
import './MainContent.css';

function MainContent() {
  return (
    <main className="main-content">
      <div className="background-image"></div>
      <section className="hero-section">
        <div className="hero-content">
          <img className="animated-logo" src="https://www.intract.io/assets/academy-animated-logo-57b2ae61.gif" alt="Intract Logo" />
          <p>
            <span className="highlight">Intract users</span> have together made more than <strong>$100 million</strong> in web3. Join them and <span className="highlight">learn how to earn crypto!</span>
          </p>
          <button className="cta-button">Get Started →</button>
        </div>
      </section>
    </main>
  );
}

export default MainContent;
     <img  src="https://static.highongrowth.xyz/enterprise/65017d0…24613adbfd67/2d1ac16ea7c9416d94a74f2ba2fe8d4a.png     
" alt="Intract Logo" />
